module.exports = {"620902001":"东北街街道","620902002":"东南街街道","620902003":"工业园街道","620902004":"新城街道","620902005":"西北街街道","620902006":"西南街街道","620902007":"玉管局生活基地街道","620902100":"西洞镇","620902101":"清水镇","620902102":"总寨镇","620902103":"金佛寺镇","620902104":"上坝镇","620902105":"三墩镇","620902106":"银达镇","620902107":"西峰镇","620902108":"泉湖镇","620902109":"果园镇","620902110":"下河清镇","620902111":"铧尖镇","620902112":"东洞镇","620902113":"丰乐镇","620902207":"黄泥堡乡","620902401":"国营下河清农场","620902403":"酒泉经济技术开发区","620902404":"十号基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620902.json
// module id = 2932
// module chunks = 0